module.exports = __webpack_public_path__ + "static/media/shirt.203601fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/Components/img/cart/shirt.png
// module id = 642
// module chunks = 0